import { FetchApiConnector } from "@frui.ts/apiclient";
import { ClassTransformOptions, serialize } from "class-transformer";
import formatISO from "date-fns/formatISO";

const serializeOptions: ClassTransformOptions = {
  excludePrefixes: ["_", "__"],
};

const serializeEntity = (value: any): string => serialize(value, serializeOptions);

const middleware = (response: Response) => {
  if (response.status >= 500 && response.status < 600) {
    throw new Error("SERVER_ERROR");
  } else {
    return response;
  }
};

const ApiConnector = new FetchApiConnector({ jsonSerializer: serializeEntity, middleware });

// eslint-disable-next-line no-extend-native
Date.prototype.toJSON = function () {
  return formatISO(this);
};

export default ApiConnector;
